/**
 * This file was automatically generated by the Stencil React Output Target.
 * Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
 * Do __not__ import components from this file as server side rendered components
 * may not hydrate due to missing Stencil runtime. Instead, import these components through the generated 'components.ts'
 * file that re-exports all components with the 'use client' directive.
 */

/* eslint-disable */

import { type OnAnswerGeneratedCallbackProps, type OnAnswerSourceClickCallbackProps, type OnChatMarkdownLinkClickedCallbackProps, type OnSearchCompletedCallbackProps, type OnSearchResultClickCallbackProps, type OramaChatBoxCustomEvent, type OramaChatCustomEvent, type OramaChatMessagesContainerCustomEvent, type OramaMarkdownCustomEvent, type OramaSearchBoxCustomEvent, type OramaSearchCustomEvent, type OramaSearchResultsCustomEvent, type OramaSourcesCustomEvent, type onStartConversationCallbackProps } from "@orama/wc-components";
import { OramaButton as OramaButtonElement, defineCustomElement as defineOramaButton } from "@orama/wc-components/dist/components/orama-button.js";
import { OramaChatAssistentMessage as OramaChatAssistentMessageElement, defineCustomElement as defineOramaChatAssistentMessage } from "@orama/wc-components/dist/components/orama-chat-assistent-message.js";
import { OramaChatBox as OramaChatBoxElement, defineCustomElement as defineOramaChatBox } from "@orama/wc-components/dist/components/orama-chat-box.js";
import { OramaChatButton as OramaChatButtonElement, defineCustomElement as defineOramaChatButton } from "@orama/wc-components/dist/components/orama-chat-button.js";
import { OramaChatMessagesContainer as OramaChatMessagesContainerElement, defineCustomElement as defineOramaChatMessagesContainer } from "@orama/wc-components/dist/components/orama-chat-messages-container.js";
import { OramaChatUserMessage as OramaChatUserMessageElement, defineCustomElement as defineOramaChatUserMessage } from "@orama/wc-components/dist/components/orama-chat-user-message.js";
import { OramaChat as OramaChatElement, defineCustomElement as defineOramaChat } from "@orama/wc-components/dist/components/orama-chat.js";
import { OramaDotsLoader as OramaDotsLoaderElement, defineCustomElement as defineOramaDotsLoader } from "@orama/wc-components/dist/components/orama-dots-loader.js";
import { OramaEmbed as OramaEmbedElement, defineCustomElement as defineOramaEmbed } from "@orama/wc-components/dist/components/orama-embed.js";
import { OramaFacets as OramaFacetsElement, defineCustomElement as defineOramaFacets } from "@orama/wc-components/dist/components/orama-facets.js";
import { OramaFooter as OramaFooterElement, defineCustomElement as defineOramaFooter } from "@orama/wc-components/dist/components/orama-footer.js";
import { OramaInput as OramaInputElement, defineCustomElement as defineOramaInput } from "@orama/wc-components/dist/components/orama-input.js";
import { OramaLogoIcon as OramaLogoIconElement, defineCustomElement as defineOramaLogoIcon } from "@orama/wc-components/dist/components/orama-logo-icon.js";
import { OramaMarkdown as OramaMarkdownElement, defineCustomElement as defineOramaMarkdown } from "@orama/wc-components/dist/components/orama-markdown.js";
import { OramaModal as OramaModalElement, defineCustomElement as defineOramaModal } from "@orama/wc-components/dist/components/orama-modal.js";
import { OramaNavigationBar as OramaNavigationBarElement, defineCustomElement as defineOramaNavigationBar } from "@orama/wc-components/dist/components/orama-navigation-bar.js";
import { OramaSearchBox as OramaSearchBoxElement, defineCustomElement as defineOramaSearchBox } from "@orama/wc-components/dist/components/orama-search-box.js";
import { OramaSearchButton as OramaSearchButtonElement, defineCustomElement as defineOramaSearchButton } from "@orama/wc-components/dist/components/orama-search-button.js";
import { OramaSearchResults as OramaSearchResultsElement, defineCustomElement as defineOramaSearchResults } from "@orama/wc-components/dist/components/orama-search-results.js";
import { OramaSearch as OramaSearchElement, defineCustomElement as defineOramaSearch } from "@orama/wc-components/dist/components/orama-search.js";
import { OramaSlidingPanel as OramaSlidingPanelElement, defineCustomElement as defineOramaSlidingPanel } from "@orama/wc-components/dist/components/orama-sliding-panel.js";
import { OramaSources as OramaSourcesElement, defineCustomElement as defineOramaSources } from "@orama/wc-components/dist/components/orama-sources.js";
import { OramaSuggestions as OramaSuggestionsElement, defineCustomElement as defineOramaSuggestions } from "@orama/wc-components/dist/components/orama-suggestions.js";
import { OramaText as OramaTextElement, defineCustomElement as defineOramaText } from "@orama/wc-components/dist/components/orama-text.js";
import { OramaTextarea as OramaTextareaElement, defineCustomElement as defineOramaTextarea } from "@orama/wc-components/dist/components/orama-textarea.js";
import { OramaToggler as OramaTogglerElement, defineCustomElement as defineOramaToggler } from "@orama/wc-components/dist/components/orama-toggler.js";
import type { EventName, StencilReactComponent } from '@stencil/react-output-target/runtime';
import { createComponent, createSSRComponent } from '@stencil/react-output-target/runtime';
import React from 'react';

type OramaButtonEvents = NonNullable<unknown>;

export const OramaButton: StencilReactComponent<OramaButtonElement, OramaButtonEvents> = typeof window !== 'undefined'
    ? /*@__PURE__*/ createComponent<OramaButtonElement, OramaButtonEvents>({
        tagName: 'orama-button',
        elementClass: OramaButtonElement,
        // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
        react: React,
        events: {} as OramaButtonEvents,
        defineCustomElement: defineOramaButton
    })
    : /*@__PURE__*/ createSSRComponent<OramaButtonElement, OramaButtonEvents>({
        tagName: 'orama-button',
        properties: {
            as: 'as',
            class: 'class',
            variant: 'variant',
            size: 'size',
            type: 'type',
            disabled: 'disabled',
            withTooltip: 'with-tooltip'
        },
        hydrateModule: import('@orama/wc-components/hydrate')
    });

type OramaChatEvents = {
    onAnswerGenerated: EventName<OramaChatCustomEvent<OnAnswerGeneratedCallbackProps>>,
    onClearChat: EventName<CustomEvent<void>>,
    onStartConversation: EventName<OramaChatCustomEvent<onStartConversationCallbackProps>>
};

export const OramaChat: StencilReactComponent<OramaChatElement, OramaChatEvents> = typeof window !== 'undefined'
    ? /*@__PURE__*/ createComponent<OramaChatElement, OramaChatEvents>({
        tagName: 'orama-chat',
        elementClass: OramaChatElement,
        // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
        react: React,
        events: {
            onAnswerGenerated: 'answerGenerated',
            onClearChat: 'clearChat',
            onStartConversation: 'startConversation'
        } as OramaChatEvents,
        defineCustomElement: defineOramaChat
    })
    : /*@__PURE__*/ createSSRComponent<OramaChatElement, OramaChatEvents>({
        tagName: 'orama-chat',
        properties: {
            placeholder: 'placeholder',
            sourceBaseUrl: 'source-base-url',
            linksTarget: 'links-target',
            linksRel: 'links-rel',
            showClearChat: 'show-clear-chat',
            defaultTerm: 'default-term',
            focusInput: 'focus-input',
            prompt: 'prompt',
            clearChatOnDisconnect: 'clear-chat-on-disconnect'
        },
        hydrateModule: import('@orama/wc-components/hydrate')
    });

type OramaChatAssistentMessageEvents = NonNullable<unknown>;

export const OramaChatAssistentMessage: StencilReactComponent<OramaChatAssistentMessageElement, OramaChatAssistentMessageEvents> = typeof window !== 'undefined'
    ? /*@__PURE__*/ createComponent<OramaChatAssistentMessageElement, OramaChatAssistentMessageEvents>({
        tagName: 'orama-chat-assistent-message',
        elementClass: OramaChatAssistentMessageElement,
        // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
        react: React,
        events: {} as OramaChatAssistentMessageEvents,
        defineCustomElement: defineOramaChatAssistentMessage
    })
    : /*@__PURE__*/ createSSRComponent<OramaChatAssistentMessageElement, OramaChatAssistentMessageEvents>({
        tagName: 'orama-chat-assistent-message',
        properties: {},
        hydrateModule: import('@orama/wc-components/hydrate')
    });

type OramaChatBoxEvents = {
    onAnswerGenerated: EventName<OramaChatBoxCustomEvent<OnAnswerGeneratedCallbackProps>>,
    onClearChat: EventName<CustomEvent<void>>,
    onStartConversation: EventName<OramaChatBoxCustomEvent<onStartConversationCallbackProps>>,
    onAnswerSourceClick: EventName<OramaChatBoxCustomEvent<OnAnswerSourceClickCallbackProps>>,
    onChatMarkdownLinkClicked: EventName<OramaChatBoxCustomEvent<OnChatMarkdownLinkClickedCallbackProps>>
};

export const OramaChatBox: StencilReactComponent<OramaChatBoxElement, OramaChatBoxEvents> = typeof window !== 'undefined'
    ? /*@__PURE__*/ createComponent<OramaChatBoxElement, OramaChatBoxEvents>({
        tagName: 'orama-chat-box',
        elementClass: OramaChatBoxElement,
        // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
        react: React,
        events: {
            onAnswerGenerated: 'answerGenerated',
            onClearChat: 'clearChat',
            onStartConversation: 'startConversation',
            onAnswerSourceClick: 'answerSourceClick',
            onChatMarkdownLinkClicked: 'chatMarkdownLinkClicked'
        } as OramaChatBoxEvents,
        defineCustomElement: defineOramaChatBox
    })
    : /*@__PURE__*/ createSSRComponent<OramaChatBoxElement, OramaChatBoxEvents>({
        tagName: 'orama-chat-box',
        properties: {
            sourceBaseUrl: 'source-base-url',
            linksTarget: 'links-target',
            linksRel: 'links-rel',
            placeholder: 'placeholder',
            autoFocus: 'auto-focus',
            prompt: 'prompt',
            clearChatOnDisconnect: 'clear-chat-on-disconnect',
            colorScheme: 'color-scheme'
        },
        hydrateModule: import('@orama/wc-components/hydrate')
    });

type OramaChatButtonEvents = NonNullable<unknown>;

export const OramaChatButton: StencilReactComponent<OramaChatButtonElement, OramaChatButtonEvents> = typeof window !== 'undefined'
    ? /*@__PURE__*/ createComponent<OramaChatButtonElement, OramaChatButtonEvents>({
        tagName: 'orama-chat-button',
        elementClass: OramaChatButtonElement,
        // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
        react: React,
        events: {} as OramaChatButtonEvents,
        defineCustomElement: defineOramaChatButton
    })
    : /*@__PURE__*/ createSSRComponent<OramaChatButtonElement, OramaChatButtonEvents>({
        tagName: 'orama-chat-button',
        properties: {
            label: 'label',
            active: 'active',
            highlight: 'highlight',
            class: 'class'
        },
        hydrateModule: import('@orama/wc-components/hydrate')
    });

type OramaChatMessagesContainerEvents = { onAnswerGenerated: EventName<OramaChatMessagesContainerCustomEvent<OnAnswerGeneratedCallbackProps>> };

export const OramaChatMessagesContainer: StencilReactComponent<OramaChatMessagesContainerElement, OramaChatMessagesContainerEvents> = typeof window !== 'undefined'
    ? /*@__PURE__*/ createComponent<OramaChatMessagesContainerElement, OramaChatMessagesContainerEvents>({
        tagName: 'orama-chat-messages-container',
        elementClass: OramaChatMessagesContainerElement,
        // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
        react: React,
        events: { onAnswerGenerated: 'answerGenerated' } as OramaChatMessagesContainerEvents,
        defineCustomElement: defineOramaChatMessagesContainer
    })
    : /*@__PURE__*/ createSSRComponent<OramaChatMessagesContainerElement, OramaChatMessagesContainerEvents>({
        tagName: 'orama-chat-messages-container',
        properties: {},
        hydrateModule: import('@orama/wc-components/hydrate')
    });

type OramaChatUserMessageEvents = NonNullable<unknown>;

export const OramaChatUserMessage: StencilReactComponent<OramaChatUserMessageElement, OramaChatUserMessageEvents> = typeof window !== 'undefined'
    ? /*@__PURE__*/ createComponent<OramaChatUserMessageElement, OramaChatUserMessageEvents>({
        tagName: 'orama-chat-user-message',
        elementClass: OramaChatUserMessageElement,
        // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
        react: React,
        events: {} as OramaChatUserMessageEvents,
        defineCustomElement: defineOramaChatUserMessage
    })
    : /*@__PURE__*/ createSSRComponent<OramaChatUserMessageElement, OramaChatUserMessageEvents>({
        tagName: 'orama-chat-user-message',
        properties: {},
        hydrateModule: import('@orama/wc-components/hydrate')
    });

type OramaDotsLoaderEvents = NonNullable<unknown>;

export const OramaDotsLoader: StencilReactComponent<OramaDotsLoaderElement, OramaDotsLoaderEvents> = typeof window !== 'undefined'
    ? /*@__PURE__*/ createComponent<OramaDotsLoaderElement, OramaDotsLoaderEvents>({
        tagName: 'orama-dots-loader',
        elementClass: OramaDotsLoaderElement,
        // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
        react: React,
        events: {} as OramaDotsLoaderEvents,
        defineCustomElement: defineOramaDotsLoader
    })
    : /*@__PURE__*/ createSSRComponent<OramaDotsLoaderElement, OramaDotsLoaderEvents>({
        tagName: 'orama-dots-loader',
        properties: {},
        hydrateModule: import('@orama/wc-components/hydrate')
    });

type OramaEmbedEvents = NonNullable<unknown>;

export const OramaEmbed: StencilReactComponent<OramaEmbedElement, OramaEmbedEvents> = typeof window !== 'undefined'
    ? /*@__PURE__*/ createComponent<OramaEmbedElement, OramaEmbedEvents>({
        tagName: 'orama-embed',
        elementClass: OramaEmbedElement,
        // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
        react: React,
        events: {} as OramaEmbedEvents,
        defineCustomElement: defineOramaEmbed
    })
    : /*@__PURE__*/ createSSRComponent<OramaEmbedElement, OramaEmbedEvents>({
        tagName: 'orama-embed',
        properties: {},
        hydrateModule: import('@orama/wc-components/hydrate')
    });

type OramaFacetsEvents = NonNullable<unknown>;

export const OramaFacets: StencilReactComponent<OramaFacetsElement, OramaFacetsEvents> = typeof window !== 'undefined'
    ? /*@__PURE__*/ createComponent<OramaFacetsElement, OramaFacetsEvents>({
        tagName: 'orama-facets',
        elementClass: OramaFacetsElement,
        // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
        react: React,
        events: {} as OramaFacetsEvents,
        defineCustomElement: defineOramaFacets
    })
    : /*@__PURE__*/ createSSRComponent<OramaFacetsElement, OramaFacetsEvents>({
        tagName: 'orama-facets',
        properties: { selectedFacet: 'selected-facet' },
        hydrateModule: import('@orama/wc-components/hydrate')
    });

type OramaFooterEvents = NonNullable<unknown>;

export const OramaFooter: StencilReactComponent<OramaFooterElement, OramaFooterEvents> = typeof window !== 'undefined'
    ? /*@__PURE__*/ createComponent<OramaFooterElement, OramaFooterEvents>({
        tagName: 'orama-footer',
        elementClass: OramaFooterElement,
        // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
        react: React,
        events: {} as OramaFooterEvents,
        defineCustomElement: defineOramaFooter
    })
    : /*@__PURE__*/ createSSRComponent<OramaFooterElement, OramaFooterEvents>({
        tagName: 'orama-footer',
        properties: {
            class: 'class',
            showKeyboardShortcuts: 'show-keyboard-shortcuts'
        },
        hydrateModule: import('@orama/wc-components/hydrate')
    });

type OramaInputEvents = { onInputChanged: EventName<CustomEvent<string>> };

export const OramaInput: StencilReactComponent<OramaInputElement, OramaInputEvents> = typeof window !== 'undefined'
    ? /*@__PURE__*/ createComponent<OramaInputElement, OramaInputEvents>({
        tagName: 'orama-input',
        elementClass: OramaInputElement,
        // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
        react: React,
        events: { onInputChanged: 'inputChanged' } as OramaInputEvents,
        defineCustomElement: defineOramaInput
    })
    : /*@__PURE__*/ createSSRComponent<OramaInputElement, OramaInputEvents>({
        tagName: 'orama-input',
        properties: {
            name: 'name',
            size: 'size',
            label: 'label',
            type: 'type',
            placeholder: 'placeholder',
            labelForScreenReaders: 'label-for-screen-readers',
            defaultValue: 'default-value',
            autoFocus: 'auto-focus',
            value: 'value'
        },
        hydrateModule: import('@orama/wc-components/hydrate')
    });

type OramaLogoIconEvents = NonNullable<unknown>;

export const OramaLogoIcon: StencilReactComponent<OramaLogoIconElement, OramaLogoIconEvents> = typeof window !== 'undefined'
    ? /*@__PURE__*/ createComponent<OramaLogoIconElement, OramaLogoIconEvents>({
        tagName: 'orama-logo-icon',
        elementClass: OramaLogoIconElement,
        // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
        react: React,
        events: {} as OramaLogoIconEvents,
        defineCustomElement: defineOramaLogoIcon
    })
    : /*@__PURE__*/ createSSRComponent<OramaLogoIconElement, OramaLogoIconEvents>({
        tagName: 'orama-logo-icon',
        properties: { size: 'size' },
        hydrateModule: import('@orama/wc-components/hydrate')
    });

type OramaMarkdownEvents = { onChatMarkdownLinkClicked: EventName<OramaMarkdownCustomEvent<OnChatMarkdownLinkClickedCallbackProps>> };

export const OramaMarkdown: StencilReactComponent<OramaMarkdownElement, OramaMarkdownEvents> = typeof window !== 'undefined'
    ? /*@__PURE__*/ createComponent<OramaMarkdownElement, OramaMarkdownEvents>({
        tagName: 'orama-markdown',
        elementClass: OramaMarkdownElement,
        // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
        react: React,
        events: { onChatMarkdownLinkClicked: 'chatMarkdownLinkClicked' } as OramaMarkdownEvents,
        defineCustomElement: defineOramaMarkdown
    })
    : /*@__PURE__*/ createSSRComponent<OramaMarkdownElement, OramaMarkdownEvents>({
        tagName: 'orama-markdown',
        properties: { content: 'content' },
        hydrateModule: import('@orama/wc-components/hydrate')
    });

type OramaModalEvents = { onModalClosed: EventName<CustomEvent<any>> };

export const OramaModal: StencilReactComponent<OramaModalElement, OramaModalEvents> = typeof window !== 'undefined'
    ? /*@__PURE__*/ createComponent<OramaModalElement, OramaModalEvents>({
        tagName: 'orama-modal',
        elementClass: OramaModalElement,
        // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
        react: React,
        events: { onModalClosed: 'modalClosed' } as OramaModalEvents,
        defineCustomElement: defineOramaModal
    })
    : /*@__PURE__*/ createSSRComponent<OramaModalElement, OramaModalEvents>({
        tagName: 'orama-modal',
        properties: {
            closeOnEscape: 'close-on-escape',
            closeOnOutsideClick: 'close-on-outside-click',
            mainTitle: 'main-title'
        },
        hydrateModule: import('@orama/wc-components/hydrate')
    });

type OramaNavigationBarEvents = NonNullable<unknown>;

export const OramaNavigationBar: StencilReactComponent<OramaNavigationBarElement, OramaNavigationBarEvents> = typeof window !== 'undefined'
    ? /*@__PURE__*/ createComponent<OramaNavigationBarElement, OramaNavigationBarEvents>({
        tagName: 'orama-navigation-bar',
        elementClass: OramaNavigationBarElement,
        // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
        react: React,
        events: {} as OramaNavigationBarEvents,
        defineCustomElement: defineOramaNavigationBar
    })
    : /*@__PURE__*/ createSSRComponent<OramaNavigationBarElement, OramaNavigationBarEvents>({
        tagName: 'orama-navigation-bar',
        properties: {
            showBackButton: 'show-back-button',
            showChatActions: 'show-chat-actions'
        },
        hydrateModule: import('@orama/wc-components/hydrate')
    });

type OramaSearchEvents = {
    onSearchCompleted: EventName<OramaSearchCustomEvent<OnSearchCompletedCallbackProps>>,
    onAnswerGenerated: EventName<OramaSearchCustomEvent<OnAnswerGeneratedCallbackProps>>
};

export const OramaSearch: StencilReactComponent<OramaSearchElement, OramaSearchEvents> = typeof window !== 'undefined'
    ? /*@__PURE__*/ createComponent<OramaSearchElement, OramaSearchEvents>({
        tagName: 'orama-search',
        elementClass: OramaSearchElement,
        // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
        react: React,
        events: {
            onSearchCompleted: 'searchCompleted',
            onAnswerGenerated: 'answerGenerated'
        } as OramaSearchEvents,
        defineCustomElement: defineOramaSearch
    })
    : /*@__PURE__*/ createSSRComponent<OramaSearchElement, OramaSearchEvents>({
        tagName: 'orama-search',
        properties: {
            placeholder: 'placeholder',
            focusInput: 'focus-input',
            sourceBaseUrl: 'source-base-url',
            linksTarget: 'links-target',
            linksRel: 'links-rel',
            disableChat: 'disable-chat',
            highlightTitle: 'highlight-title',
            highlightDescription: 'highlight-description'
        },
        hydrateModule: import('@orama/wc-components/hydrate')
    });

type OramaSearchBoxEvents = {
    onSearchCompleted: EventName<OramaSearchBoxCustomEvent<OnSearchCompletedCallbackProps>>,
    onSearchResultClick: EventName<OramaSearchBoxCustomEvent<OnSearchResultClickCallbackProps>>,
    onClearChat: EventName<CustomEvent<void>>,
    onStartConversation: EventName<OramaSearchBoxCustomEvent<onStartConversationCallbackProps>>,
    onAnswerGenerated: EventName<OramaSearchBoxCustomEvent<OnAnswerGeneratedCallbackProps>>,
    onAnswerSourceClick: EventName<OramaSearchBoxCustomEvent<OnAnswerSourceClickCallbackProps>>,
    onChatMarkdownLinkClicked: EventName<OramaSearchBoxCustomEvent<OnChatMarkdownLinkClickedCallbackProps>>,
    onModalClosed: EventName<CustomEvent<any>>,
    onModalStatusChanged: EventName<OramaSearchBoxCustomEvent<{ open: boolean; id: HTMLElement }>>
};

export const OramaSearchBox: StencilReactComponent<OramaSearchBoxElement, OramaSearchBoxEvents> = typeof window !== 'undefined'
    ? /*@__PURE__*/ createComponent<OramaSearchBoxElement, OramaSearchBoxEvents>({
        tagName: 'orama-search-box',
        elementClass: OramaSearchBoxElement,
        // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
        react: React,
        events: {
            onSearchCompleted: 'searchCompleted',
            onSearchResultClick: 'searchResultClick',
            onClearChat: 'clearChat',
            onStartConversation: 'startConversation',
            onAnswerGenerated: 'answerGenerated',
            onAnswerSourceClick: 'answerSourceClick',
            onChatMarkdownLinkClicked: 'chatMarkdownLinkClicked',
            onModalClosed: 'modalClosed',
            onModalStatusChanged: 'modalStatusChanged'
        } as OramaSearchBoxEvents,
        defineCustomElement: defineOramaSearchBox
    })
    : /*@__PURE__*/ createSSRComponent<OramaSearchBoxElement, OramaSearchBoxEvents>({
        tagName: 'orama-search-box',
        properties: {
            colorScheme: 'color-scheme',
            open: 'open',
            facetProperty: 'facet-property',
            sourceBaseUrl: 'source-base-url',
            linksTarget: 'links-target',
            linksRel: 'links-rel',
            disableChat: 'disable-chat',
            layout: 'layout',
            highlightTitle: 'highlight-title',
            highlightDescription: 'highlight-description',
            placeholder: 'placeholder',
            chatPlaceholder: 'chat-placeholder',
            searchPlaceholder: 'search-placeholder',
            showKeyboardShortcuts: 'show-keyboard-shortcuts'
        },
        hydrateModule: import('@orama/wc-components/hydrate')
    });

type OramaSearchButtonEvents = NonNullable<unknown>;

export const OramaSearchButton: StencilReactComponent<OramaSearchButtonElement, OramaSearchButtonEvents> = typeof window !== 'undefined'
    ? /*@__PURE__*/ createComponent<OramaSearchButtonElement, OramaSearchButtonEvents>({
        tagName: 'orama-search-button',
        elementClass: OramaSearchButtonElement,
        // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
        react: React,
        events: {} as OramaSearchButtonEvents,
        defineCustomElement: defineOramaSearchButton
    })
    : /*@__PURE__*/ createSSRComponent<OramaSearchButtonElement, OramaSearchButtonEvents>({
        tagName: 'orama-search-button',
        properties: {
            size: 'size',
            colorScheme: 'color-scheme'
        },
        hydrateModule: import('@orama/wc-components/hydrate')
    });

type OramaSearchResultsEvents = { onSearchResultClick: EventName<OramaSearchResultsCustomEvent<OnSearchResultClickCallbackProps>> };

export const OramaSearchResults: StencilReactComponent<OramaSearchResultsElement, OramaSearchResultsEvents> = typeof window !== 'undefined'
    ? /*@__PURE__*/ createComponent<OramaSearchResultsElement, OramaSearchResultsEvents>({
        tagName: 'orama-search-results',
        elementClass: OramaSearchResultsElement,
        // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
        react: React,
        events: { onSearchResultClick: 'searchResultClick' } as OramaSearchResultsEvents,
        defineCustomElement: defineOramaSearchResults
    })
    : /*@__PURE__*/ createSSRComponent<OramaSearchResultsElement, OramaSearchResultsEvents>({
        tagName: 'orama-search-results',
        properties: {
            sourceBaseUrl: 'source-base-url',
            linksTarget: 'links-target',
            linksRel: 'links-rel',
            searchTerm: 'search-term',
            loading: 'loading',
            error: 'error',
            highlightTitle: 'highlight-title',
            highlightDescription: 'highlight-description'
        },
        hydrateModule: import('@orama/wc-components/hydrate')
    });

type OramaSlidingPanelEvents = NonNullable<unknown>;

export const OramaSlidingPanel: StencilReactComponent<OramaSlidingPanelElement, OramaSlidingPanelEvents> = typeof window !== 'undefined'
    ? /*@__PURE__*/ createComponent<OramaSlidingPanelElement, OramaSlidingPanelEvents>({
        tagName: 'orama-sliding-panel',
        elementClass: OramaSlidingPanelElement,
        // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
        react: React,
        events: {} as OramaSlidingPanelEvents,
        defineCustomElement: defineOramaSlidingPanel
    })
    : /*@__PURE__*/ createSSRComponent<OramaSlidingPanelElement, OramaSlidingPanelEvents>({
        tagName: 'orama-sliding-panel',
        properties: {
            backdrop: 'backdrop',
            open: 'open'
        },
        hydrateModule: import('@orama/wc-components/hydrate')
    });

type OramaSourcesEvents = { onAnswerSourceClick: EventName<OramaSourcesCustomEvent<OnAnswerSourceClickCallbackProps>> };

export const OramaSources: StencilReactComponent<OramaSourcesElement, OramaSourcesEvents> = typeof window !== 'undefined'
    ? /*@__PURE__*/ createComponent<OramaSourcesElement, OramaSourcesEvents>({
        tagName: 'orama-sources',
        elementClass: OramaSourcesElement,
        // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
        react: React,
        events: { onAnswerSourceClick: 'answerSourceClick' } as OramaSourcesEvents,
        defineCustomElement: defineOramaSources
    })
    : /*@__PURE__*/ createSSRComponent<OramaSourcesElement, OramaSourcesEvents>({
        tagName: 'orama-sources',
        properties: {
            sources: 'sources',
            sourceBaseURL: 'source-base-u-r-l',
            linksTarget: 'links-target',
            linksRel: 'links-rel'
        },
        hydrateModule: import('@orama/wc-components/hydrate')
    });

type OramaSuggestionsEvents = NonNullable<unknown>;

export const OramaSuggestions: StencilReactComponent<OramaSuggestionsElement, OramaSuggestionsEvents> = typeof window !== 'undefined'
    ? /*@__PURE__*/ createComponent<OramaSuggestionsElement, OramaSuggestionsEvents>({
        tagName: 'orama-suggestions',
        elementClass: OramaSuggestionsElement,
        // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
        react: React,
        events: {} as OramaSuggestionsEvents,
        defineCustomElement: defineOramaSuggestions
    })
    : /*@__PURE__*/ createSSRComponent<OramaSuggestionsElement, OramaSuggestionsEvents>({
        tagName: 'orama-suggestions',
        properties: { as: 'as' },
        hydrateModule: import('@orama/wc-components/hydrate')
    });

type OramaTextEvents = NonNullable<unknown>;

export const OramaText: StencilReactComponent<OramaTextElement, OramaTextEvents> = typeof window !== 'undefined'
    ? /*@__PURE__*/ createComponent<OramaTextElement, OramaTextEvents>({
        tagName: 'orama-text',
        elementClass: OramaTextElement,
        // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
        react: React,
        events: {} as OramaTextEvents,
        defineCustomElement: defineOramaText
    })
    : /*@__PURE__*/ createSSRComponent<OramaTextElement, OramaTextEvents>({
        tagName: 'orama-text',
        properties: {
            as: 'as',
            styledAs: 'styled-as',
            bold: 'bold',
            class: 'class',
            align: 'align',
            variant: 'variant',
            inactive: 'inactive'
        },
        hydrateModule: import('@orama/wc-components/hydrate')
    });

type OramaTextareaEvents = NonNullable<unknown>;

export const OramaTextarea: StencilReactComponent<OramaTextareaElement, OramaTextareaEvents> = typeof window !== 'undefined'
    ? /*@__PURE__*/ createComponent<OramaTextareaElement, OramaTextareaEvents>({
        tagName: 'orama-textarea',
        elementClass: OramaTextareaElement,
        // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
        react: React,
        events: {} as OramaTextareaEvents,
        defineCustomElement: defineOramaTextarea
    })
    : /*@__PURE__*/ createSSRComponent<OramaTextareaElement, OramaTextareaEvents>({
        tagName: 'orama-textarea',
        properties: {
            value: 'value',
            maxRows: 'max-rows',
            minRows: 'min-rows',
            placeholder: 'placeholder',
            autoFocus: 'auto-focus'
        },
        hydrateModule: import('@orama/wc-components/hydrate')
    });

type OramaTogglerEvents = NonNullable<unknown>;

export const OramaToggler: StencilReactComponent<OramaTogglerElement, OramaTogglerEvents> = typeof window !== 'undefined'
    ? /*@__PURE__*/ createComponent<OramaTogglerElement, OramaTogglerEvents>({
        tagName: 'orama-toggler',
        elementClass: OramaTogglerElement,
        // @ts-ignore - React type of Stencil Output Target may differ from the React version used in the Nuxt.js project, this can be ignored.
        react: React,
        events: {} as OramaTogglerEvents,
        defineCustomElement: defineOramaToggler
    })
    : /*@__PURE__*/ createSSRComponent<OramaTogglerElement, OramaTogglerEvents>({
        tagName: 'orama-toggler',
        properties: { performInitialAnimation: 'perform-initial-animation' },
        hydrateModule: import('@orama/wc-components/hydrate')
    });
